import React from 'react';
import { Table } from 'react-bootstrap';

const SSRotatorTable = ({ report }) => {
    const rows = report.map(({ zone, ssId }) => (
        <tr>
            <td>{zone}</td>
            <td>{ssId}</td>
        </tr>
    ));

    return (
        <Table bordered responsive>
            <thead>
            <tr>
                <th>Zone</th>
                <th>SS ID</th>
            </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
};

export default SSRotatorTable;


// WEBPACK FOOTER //
// ./src/scenes/PeerClickOfferDomain/components/Table/index.js